import { Box, Grid, Typography } from "@mui/material";
import * as React from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import { t } from "i18next";
export default function MWExceptionList() {
  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
      >
        <Grid item>
          <DescriptionIcon color="primary" />
        </Grid>
        <Grid item>
          <Typography variant="subtitle1" color="#000000">
            {t("common.nocontentAvail!", { ns: ["home"] })}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
